module.exports = __webpack_public_path__ + "img/icon-pagination-left-stop.aef747f7.svg";